import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Home from './Home/Home';
import Header from './Home/components/Header';
import Vacancies from './Vacancies/Vacancies';
import Sidebar from './Dashboard/components/Sidebar';
import ListJobVacancy from './Dashboard/ListJobVacancy';
import DashboardCompany from './Dashboard/Dashboard';
import AddNewJob from './Dashboard/AddNewJob';
import Signup from './Auth/Signup';
import Login from './Auth/Login';
import { JobProvider } from './Context/JobContext';
import ChangePassword from './Dashboard/ChangePassword';
import Profile from './Dashboard/Profile';


function App() {
  return (
    <JobProvider> 
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vacancies" element={<Vacancies />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard/*" element={<DashboardWithSidebar />} />
        </Routes>
      </BrowserRouter>
    </JobProvider>
  );
}

function DashboardWithSidebar() {
  const location = useLocation();

  const isDashboardRoute = location.pathname.startsWith('/dashboard');

  return (
    <div className="flex">
      {isDashboardRoute && <Sidebar />}
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<DashboardCompany />} />
          <Route path="/list-job-vacancy" element={<ListJobVacancy />} />
          <Route path="/list-job-vacancy/form" element={<AddNewJob />} />
          <Route path="/list-job-vacancy/form/:id" element={<AddNewJob />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
